import React from "react";

import {
    FiBookOpen,
    FiRefreshCw,
} from "react-icons/fi";

/*
|--------------------------------------------------------------------------
| COMPONENT
|--------------------------------------------------------------------------
*/

const LedgerHeader = ({
    loading = false,
    onRefresh,
}) => {
    return (
        <header className="customer-ledger-header">
            <div className="customer-ledger-heading">
                <span className="customer-ledger-heading-icon">
                    <FiBookOpen />
                </span>

                <div>
                    <h1>
                        Customer Ledger
                    </h1>

                    <p>
                        Track receivables,
                        payments, credit notes
                        and customer outstanding
                        balances from one place.
                    </p>
                </div>
            </div>

            <button
                type="button"
                className="customer-ledger-refresh"
                disabled={
                    loading
                }
                onClick={
                    onRefresh
                }
            >
                <FiRefreshCw
                    className={
                        loading
                            ? "customer-ledger-spinner"
                            : ""
                    }
                />

                {loading
                    ? "Refreshing..."
                    : "Refresh"}
            </button>
        </header>
    );
};

export default LedgerHeader;